import type { FilterableIssue, MatcherCreator } from '../types.tsx';

export const filteredIssueIdsMatcherCreator: MatcherCreator<string[] | string, FilterableIssue> =
	(value, { filteredIssueIds }) =>
	({ id }) =>
		filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;
